import script from "./TimeRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeRecords.vue?vue&type=script&setup=true&lang=js"

import "./TimeRecords.vue?vue&type=style&index=0&id=4136df4d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4136df4d"]])

export default __exports__